import { Button } from '@material-ui/core';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import PersonIcon from '@material-ui/icons/Person';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react'
import { Link } from "react-router-dom";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Lista from './Lista';
import useStyles from "./styles"
import Lang from "../../Lang"

function Rss() {

    const classes = useStyles()
    const [navigation, setNavigation] = useState(0)
    const handleNavigation = (event, newValue) => {
        setNavigation(newValue);
    }

    return (
        <div className={classes.main_section}>
            <div className={classes.dir}>
                <Button component={Link} to="/Practice" variant="outlined" className={classes.back_home_container}><ArrowBackIosIcon className={classes.back_home} /></Button>
                <h1 className={classes.title}><Lang props={"Cartas"} /></h1>
                <BottomNavigation value={navigation} onChange={handleNavigation} className={classes.navigation} showLabels={true} >
                    <BottomNavigationAction className={classes.navigation_item} label={<Lang props={"Mías"} />} icon={<PersonIcon />} />
                    <BottomNavigationAction className={classes.navigation_item} label={<Lang props={"Populares"} />} icon={<EmojiEmotionsIcon />} />
                    <BottomNavigationAction className={classes.navigation_item} label={<Lang props={"Explorar"} />} icon={<SearchIcon />} />
                </BottomNavigation>
            </div>

            <Lista navigation={navigation} setNavigation={setNavigation} />

        </div>
    )
}

export default Rss
